export default {
  desktop_access:
    'Se requiere acceso móvil<br/><br/>Para disfrutar de una experiencia perfecta con Bitcash Wallet, cambie a su dispositivo móvil. Recomendamos utilizar la última versión de su navegador móvil.<br/><br/> Los navegadores compatibles incluyen',
  desktop_access_2:
    'Para lograr total compatibilidad y seguridad, mantenga actualizado su navegador y dispositivo móvil.',
}
